export const Fog = () => {
  return <fogExp2 attach="fog" color={'#d8d8ff'} density={0.001} />
}
